<div class="flex justify-center padding-3rem-4rem">
  <div class="max-w-2xl w-full flex-col flex">

    <section class="text-center space-y-6 mb-12">
      <img [src]="logoPath" alt="logo" class="h-24 max-w-[350px] object-contain mx-auto">
      <h1 class="text-3xl font-bold text-[#1b3777] mb-8">{{transferOrg}}</h1>
      <h2 class="text-md font-medium text-gray-700 mt-6">{{'CANCEL_TRANSFER.DESC' | transloco}}</h2>
    </section>

    <!-- Action Button -->
    <div class="w-full flex justify-center">
      <button
        class="px-12 py-3 rounded-[4px] font-semibold text-lg leading-6 flex justify-center cancel-button min-w-[280px]"
        (click)="openCancelConfirmModal()" [disabled]="isLoading" class="bg-danger-text-white">
        @if (!isLoading) {
          <span>{{'CANCEL_TRANSFER.BUTTON_TEXT' | transloco}}</span>
        }
        @if (isLoading) {
          <span class="flex items-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{'CANCEL_TRANSFER.CANCELLING' | transloco}}...
          </span>
        }
      </button>
    </div>
  </div>
</div>